<!-- <div class="exchange-rate-row">
  <h4 class="exchange-rate-label">{{label.exchangeRate}}</h4>
  <div class="exchange-list">
    <p *ngFor="let exInfo of exchangeInfo; index as i" class="mat-body exchange-rate-value" [ngClass]="{'special-exchange': i == 1}" >
      {{ exInfo }}
    </p>
  </div>
</div> -->
<!-- TODO: once the fee qoute api is working, we need to update this logic to display proper exchange rate details -->
<section class="exchange-rate-container">
  <div
    class="exchange-rate-details"
    *ngIf="fxRateObj['currency'] === 'USD'; else noneUSCurrency"
  >
    1 USDC = {{ fxRateObj.fxRate }} {{ fxRateObj.currency }}
  </div>
  <ng-template #noneUSCurrency>
    <div class="exchange-rate-details">
      1 USDC = 1 USD = {{ fxRateObj.fxRate }} {{ fxRateObj.currency }}
    </div>
  </ng-template>
</section>
